function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUsb50Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0033AD",
      fillOpacity: 1
    },
    d: "M 33.332031 20.832031 L 35.417969 20.832031 L 35.417969 25 L 27.082031 25 L 27.082031 12.5 L 31.25 12.5 L 25 4.167969 L 18.75 12.5 L 22.917969 12.5 L 22.917969 29.167969 L 14.582031 29.167969 L 14.582031 24.421875 C 15.824219 23.699219 16.667969 22.371094 16.667969 20.832031 C 16.667969 18.53125 14.800781 16.667969 12.5 16.667969 C 10.199219 16.667969 8.332031 18.53125 8.332031 20.832031 C 8.332031 22.371094 9.175781 23.699219 10.417969 24.421875 L 10.417969 29.167969 C 10.417969 31.464844 12.285156 33.332031 14.582031 33.332031 L 22.917969 33.332031 L 22.917969 38.078125 C 21.628906 38.816406 20.835938 40.183594 20.832031 41.667969 C 20.832031 43.96875 22.699219 45.832031 25 45.832031 C 27.300781 45.832031 29.167969 43.96875 29.167969 41.667969 C 29.167969 40.128906 28.324219 38.800781 27.082031 38.078125 L 27.082031 29.167969 L 35.417969 29.167969 C 37.714844 29.167969 39.582031 27.296875 39.582031 25 L 39.582031 20.832031 L 41.667969 20.832031 L 41.667969 12.5 L 33.332031 12.5 Z M 33.332031 20.832031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsb50Px);
export default __webpack_public_path__ + "static/media/ic_usb_50px.7967b00b1c8b978cc2d15d50cd45d03d.svg";
export { ForwardRef as ReactComponent };